export const AGENT_REQUESTS_VERSION = 1;
export const APPLICATION_RPC_MAX_BYTES = 128 * 1024;
export const APPLICATION_REQUEST_TIMEOUT_MS = 30000;
export const AGENT_REQUESTS_HEADER = 'x-borgee-agent-requests-version';
/** Authority is checked by the application against the server's trusted caller context. */
export function applicationRequest(action, input = {}, expiresAt = Date.now() + APPLICATION_REQUEST_TIMEOUT_MS) {
    return { body: { action, input: input, expires_at: expiresAt } };
}
/** Sender expiry limits when work can start; it grants no caller authority or rollback. */
export function parseApplicationBody(value, now = Date.now()) {
    if (!value || typeof value !== 'object' || Array.isArray(value))
        throw new Error('invalid_application_request');
    const body = value;
    if (Object.keys(body).some(key => !['action', 'input', 'expires_at'].includes(key)) || typeof body.action !== 'string'
        || !body.input || typeof body.input !== 'object' || Array.isArray(body.input)
        || Object.hasOwn(body, 'expires_at') && (!Number.isSafeInteger(body.expires_at) || body.expires_at <= 0 || body.expires_at > 8_640_000_000_000_000))
        throw new Error('invalid_application_request');
    if (typeof body.expires_at === 'number' && body.expires_at <= now)
        throw new Error('application_request_expired');
    return body;
}
export function sessionMessageApplicationData(agentId, target) {
    return { protocol: 'remote-control', version: 1, action: 'start_turn', input: {
            agent_id: agentId, binding_id: target.binding_id, native_session_id: target.native_session_id, connection_generation: target.connection_generation,
        } };
}
export function isSessionMessageApplicationData(value) {
    return !!value && typeof value === 'object' && !Array.isArray(value) && value.protocol === 'remote-control';
}
export function parseSessionMessageApplicationData(value) {
    if (!isSessionMessageApplicationData(value) || value.version !== 1 || value.action !== 'start_turn'
        || Object.keys(value).length !== 4 || !value.input || typeof value.input !== 'object' || Array.isArray(value.input))
        throw new Error('invalid_session_message');
    const input = value.input;
    const fields = ['agent_id', 'binding_id', 'native_session_id', 'connection_generation'];
    if (Object.keys(input).length !== fields.length || !fields.every(key => typeof input[key] === 'string' && /^[A-Za-z0-9_:.@/-]{1,512}$/.test(input[key])))
        throw new Error('invalid_session_message');
    return value;
}
export function parseApplicationRequestContext(value, now = Date.now()) {
    if (!value || typeof value !== 'object' || Array.isArray(value))
        throw new Error('invalid_request_context');
    const context = value;
    const required = ['actor_id', 'actor_role', 'channel_id', 'agent_id', 'connection_generation', 'is_agent_owner', 'channel_writable', 'deadline_at'];
    if (Object.keys(context).length !== required.length || !required.every(key => Object.hasOwn(context, key))
        || !['actor_id', 'channel_id', 'agent_id', 'connection_generation'].every(key => typeof context[key] === 'string' && /^[A-Za-z0-9_:.@/-]{1,512}$/.test(context[key]))
        || typeof context.actor_role !== 'string' || !/^[A-Za-z0-9_:.@/-]{1,512}$/.test(context.actor_role)
        || typeof context.is_agent_owner !== 'boolean' || typeof context.channel_writable !== 'boolean'
        || !Number.isSafeInteger(context.deadline_at) || context.deadline_at <= now)
        throw new Error('invalid_request_context');
    return value;
}
//# sourceMappingURL=application-request.js.map